import Vue from 'vue'
import request from '@/helpers/request'
import snack from '@/helpers/snack'
import moment from 'moment'

const timeZoneMoscowHeader = {
  'X-Timezone': 'Europe/Moscow',
}

function findByType(plans, type) {
  return plans.find(plan => plan.type === type) ?? null
}

function numberFloatFormating(percents) {
  percents = parseFloat(percents)
  return percents.toFixed(2)
}

function getDaysCountOfMonth(month) {
  return moment(month, 'YYYY-MM-DD hh:mm:ss').daysInMonth()
}

function getDailyAverage(value, month) {
  return numberFloatFormating(value / getDaysCountOfMonth(month))
}

const findManicureRevenue = plans => findByType(plans, 'manicure')
const findPedicureRevenue = plans => findByType(plans, 'pedicure')
const findUnionRevenue = plan => findByType(plan, 'union')

const commonIndicator = plans =>
  (findManicureRevenue(plans)?.indicator ?? null) + (findPedicureRevenue(plans)?.indicator ?? null)

class calcUnitObjectData {
  constructor(plans, daily = false) {
    this.plans = plans
    this.daily = daily
    const findManicureRevenuePlan = findManicureRevenue(this.plans)
    const findPedicureRevenuePlan = findPedicureRevenue(this.plans)
    const findUnionRevenuePlan = findUnionRevenue(this.plans)

    const findFirstPlan = this.plans[0]
    this.unitRevenueObj = {
      begin_at: findFirstPlan.begin_at,
      end_at: findFirstPlan.end_at,
      company_id: findFirstPlan.company_id,
      unit: findFirstPlan.unit,
      unit_id: findFirstPlan.unit_id,
      manicure_id: findManicureRevenuePlan?.id ?? null,
      pedicure_id: findPedicureRevenuePlan?.id ?? null,
      manicure_indicator: findManicureRevenuePlan?.indicator ?? null,
      pedicure_indicator: findPedicureRevenuePlan?.indicator ?? null,
      manicure_percent: findManicureRevenuePlan?.percent ?? null,
      pedicure_percent: findPedicureRevenuePlan?.percent ?? null,
      manicure_period: findManicureRevenuePlan?.period ?? null,
      pedicure_period: findPedicureRevenuePlan?.period ?? null,
      manicure_plan: findManicureRevenuePlan?.plan ?? null,
      pedicure_plan: findPedicureRevenuePlan?.plan ?? null,
      union_plan: findUnionRevenuePlan?.plan ?? null,
      union_indicator: findUnionRevenuePlan?.indicator ?? null,
      union_percent: findUnionRevenuePlan?.percent ?? null,
    }
    if (this.daily) {
      this.unitRevenueObj.common_indicator = getDailyAverage(commonIndicator(this.plans), findFirstPlan.begin_at)
    } else {
      this.unitRevenueObj.common_indicator = commonIndicator(this.plans)
    }
  }
  getUnitRevenueObj() {
    return this.unitRevenueObj
  }
}

export default {
  async GET_UNIT_REVENUE_BY_DATA({ commit }, [revenueType, params]) {
    try {
      if (revenueType === 'common') {
        const {
          data: {
            data: { items: commonRevenueDayliResponse },
          },
        } = await request(
          'GET',
          `${Vue.config.server}/${Vue.config.modules.crm.api.unitRevenue.common.all}`,
          { params: params },
          true,
          timeZoneMoscowHeader,
        )
        return Object.values(commonRevenueDayliResponse).map(commonResponseday =>
          new calcUnitObjectData(commonResponseday).getUnitRevenueObj(),
        )
      } else {
        const {
          data: {
            data: { items: commonRevenueDayliResponse },
          },
        } = await request(
          'GET',
          `${Vue.config.server}/${Vue.config.modules.crm.api.unitRevenue[revenueType].all}`,
          { params: params },
          true,
          timeZoneMoscowHeader,
        )
        return commonRevenueDayliResponse
      }
    } catch (e) {
      this.$notify({
        group: 'hasBottomNavigation',
        title: 'Ошибка загрузки данных',
        type: 'error',
      })
    }
  },
  async GET_UNIT_REVENUE_PLANS({ commit }, [revenueType, params, isReturnOnly = false]) {
    try {
      if (params.showPreloader) {
        commit('setLoad', true)
      }
      const {
        data: { data: revenueResponse },
      } = await request(
        'GET',
        `${Vue.config.server}/${Vue.config.modules.crm.api.unitRevenue[revenueType].all}`,
        { params: params },
        true,
        timeZoneMoscowHeader,
      )
      if (revenueType === 'common') {
        const isDaily = true
        const commonPlans = Object.values(revenueResponse.items).map(plan =>
          new calcUnitObjectData(plan, isDaily).getUnitRevenueObj(),
        )

        commit('setUnitPlans', [revenueType, []])
        commit('setUnitPlansCounter', [revenueType, revenueResponse.count])
        commit('updateUnitPlans', [revenueType, commonPlans])
        commit('setUnitPlanFilters', [revenueType, revenueResponse.filters])

        return revenueResponse
      } else {
        if (isReturnOnly) {
          return revenueResponse
        }
        if (!params.offset && params.limit) {
          commit('setUnitPlans', [revenueType, []])
          commit('setUnitPlansCounter', [revenueType, revenueResponse.count])
        }
        commit('updateUnitPlans', [revenueType, revenueResponse.items])
        commit('setUnitPlanFilters', [revenueType, revenueResponse.filters])

        return revenueResponse
      }
    } catch (e) {
      this.$notify({
        group: 'hasBottomNavigation',
        title: 'Ошибка загрузки данных',
        type: 'error',
      })
    } finally {
      commit('setLoad', false)
    }
  },
  async CREATE_UNIT_REVENUE_PLAN({ commit }, [revenueType, params]) {
    try {
      commit('setLoad', true)
      const {
        data: { data: revenueCreateResponse },
      } = await request(
        'POST',
        `${Vue.config.server}/${Vue.config.modules.crm.api.unitRevenue[revenueType].create}`,
        { params: params },
        true,
        timeZoneMoscowHeader,
      )
      let revenueCreatedObject
      if (revenueType === 'manicure' || revenueType === 'pedicure') {
        revenueCreatedObject = revenueCreateResponse.items.find(item => item.period === 2)
      } else {
        revenueCreatedObject = revenueCreateResponse
      }
      commit('appendUnitPlans', [revenueType, revenueCreatedObject])
      snack.add(Vue.config.localization.ru.savedMessage, 'primary', null)
    } catch (error) {
      snack.add(Vue.config.localization.ru.error, 'error', null)
    } finally {
      commit('setLoad', false)
    }
  },
  async UPDATE_UNIT_REVENUE_PLAN({ commit }, [revenueType, data]) {
    try {
      commit('setLoad', true)

      const {
        data: { data: updatedRevenueResponse },
      } = await request(
        'PUT',
        `${Vue.config.server}/${Vue.config.modules.crm.api.unitRevenue[revenueType].one.replace('$id', data.id)}`,
        { params: data.params },
        true,
        timeZoneMoscowHeader,
      )

      commit('changeUnitPlan', [revenueType, updatedRevenueResponse])
      snack.add(Vue.config.localization.ru.refreshedMessage, 'primary', null)
    } catch (error) {
      snack.add(Vue.config.localization.ru.error, 'error', null)
    } finally {
      commit('setLoad', false)
    }
  },
  async DELETE_UNIT_REVENUE_PLAN({ commit }, [revenueType, data]) {
    const removingRevenue = true
    try {
      if (data.showPreloader) {
        commit('setLoad', true)
      }
      await request(
        'DELETE',
        `${Vue.config.server}/${Vue.config.modules.crm.api.unitRevenue[revenueType].one.replace('$id', data.id)}`,
        {},
        true,
        timeZoneMoscowHeader,
      )
      commit('changeUnitPlan', { revenueType, data, removingRevenue })
      snack.add(Vue.config.localization.ru.deleteMessage, 'primary', null)
    } catch (error) {
      snack.add(Vue.config.localization.ru.error, 'error', null)
    } finally {
      commit('setLoad', false)
    }
  },
}
